import type { FC } from 'react'

import { ScrollRestoration } from 'react-router-dom'
import { Routes } from 'common/constants'
import { ServiceButton } from 'components/service-button'

import { TServiceItems } from '../types/MyServices.types'

export const MyServicesView: FC<{
  items: TServiceItems[]
}> = ({ items }) => (
  <>
    {items.map(
      ({
        details,
        status,
        subject,
        icon,
        protocol,
        hasUpdate,
        openingDate,
        areaResponse,
        additionalInfo,
        pendingReason,
        externalId,
      }) => (
        <ServiceButton
          key={protocol}
          title={subject}
          route={Routes.SERVICE_DETAILS}
          details={details}
          info={{
            hasUpdate: Boolean(hasUpdate),
            openingDate,
            protocol,
            areaResponse,
            additionalInfo,
            pendingReason,
            externalId,
          }}
          icon={icon}
          status={status}
        />
      ),
    )}
    <ScrollRestoration />
  </>
)
